export const ITEM_UPDATE_LIMIT = 10;
